import dynamic from 'next/dynamic'

export const DynamicAddAndCreateListDrawer = dynamic(
  () => import('.').then((mod) => mod.AddAndCreateListDrawer),
  { ssr: false },
)
